import React from 'react'
import {makeStyles, Typography} from "@material-ui/core"

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(5),
        paddingTop: theme.spacing(3),
    },
    content: {
        textAlign: 'center',
        marginTop: theme.spacing(7),
        marginBottom: theme.spacing(3),
    },
    paragraphSpacer: {
        marginBottom: theme.spacing(5),
    },
    tHead: {
        backgroundColor: "skyblue"
    },
    tH: {
        paddingLeft: 24,
        paddingRight: 24,
    },
    tD: {
        border: "1px ridge",
        padding: 8
    },
}));

function Cookies() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant="h1" className={classes.content}>
                Politique d’utilisation des cookies de Cyklad
            </Typography>
            <Typography variant="caption" gutterBottom>Date de la dernière modification : 20 juillet 2021</Typography>
            <div className={classes.paragraphSpacer}/>
            <Typography gutterBottom>
                Veuillez consulter régulièrement les dernières mises à jour apportées à cette Politique d’utilisation
                des
                cookies.
            </Typography>
            <Typography gutterBottom>
                Comme il est décrit dans la Section « Cookies et autres technologies de traçage » de notre Déclaration
                de confidentialité, Cyklad SAS, les sociétés affiliées de Cyklad, ses filiales (ensemble, «
                Cyklad »), ainsi que les fournisseurs de services et partenaires tiers de Cyklad utilisent des
                cookies
                et des technologies similaires (ensemble, les « Cookies », veuillez vous référer à la Section «
                Qu’est-ce
                qu’un cookie » ci-dessous) sur nos sites internet, produits, applications mobiles et offres et
                applications
                réalisées en partenariat (ensemble, les « Services »).
            </Typography>
            <Typography gutterBottom>
                Cette Politique d’utilisation des Cookies explique comment les Cookies et autres technologies similaires
                sont
                utilisés pour les Services qui font référence à cette Politique. Pour plus d’information sur la manière
                dont
                nous protégeons votre vie privée lorsque nous utilisons des Cookies et d’autres données, veuillez
                consulter
                notre Déclaration de confidentialité.
            </Typography>
            <div className={classes.paragraphSpacer}/>
            <Typography variant="h2" gutterBottom className={classes.color}>
                Qu’est-ce qu’un Cookie
            </Typography>
            <br/>
            <Typography gutterBottom>
                Un « Cookie » est un petit fichier créé par un site internet et stocké sur votre appareil. Les Cookies
                contiennent souvent une série de nombres et de lettres qui permettent d’identifier de façon unique votre
                appareil, bien qu’ils puissent également contenir d’autres informations. Les Cookies remplissent de
                nombreuses
                fonctions, notamment celle de mémoriser vos préférences ou de permettre aux Services de fonctionner.
            </Typography>
            <Typography gutterBottom>
                Il existe différents types de Cookies :
            </Typography>
            <ul>
                <li>
                    <Typography gutterBottom>Les Cookies sont « <b>Persistants</b> »,
                        « <b>Permanents</b> », ou « <b>de Session</b> » :</Typography>
                    <ul>
                        <li><Typography gutterBottom>Les Cookies persistants et permanents restent
                            sur votre appareil même après votre déconnexion. Ces Cookies demeureront sur votre appareil
                            jusqu’à ce
                            que vous les supprimiez manuellement, ou que votre navigateur les supprime conformément à la
                            durée de
                            vie prévue par le fichier Cookie.</Typography></li>
                        <li><Typography gutterBottom>Les Cookies de session sont supprimés dès que
                            vous fermez votre navigateur web.</Typography></li>
                    </ul>
                </li>
                <li>
                    <Typography gutterBottom>Les Cookies peuvent aussi être
                        « <b>Propriétaires</b> » ou « <b>Tiers</b> » :</Typography>
                    <ul>
                        <li><Typography gutterBottom>Les <b>Cookies propriétaires</b> sont des
                            Cookies placés par Cyklad.</Typography></li>
                        <li><Typography gutterBottom>Les <b>Cookies tiers</b> sont placés par nos
                            partenaires, fournisseurs ou tout autre tiers. Nous ne contrôlons pas la collecte ou l’usage
                            ultérieur
                            de données par les tiers plaçant des Cookies Tiers.</Typography></li>
                    </ul>
                </li>
                <li>
                    <Typography gutterBottom>Nous classifions également les Cookies selon leur
                        caractère « <b>Essentiel</b> », « <b>Fonctionnel</b> », « <b>Améliorant les performances</b> »,
                        ou
                        « <b>Publicitaire</b> » :</Typography>
                    <ul>
                        <li><Typography gutterBottom>Les <b>Cookies essentiels</b> sont
                            nécessaires au fonctionnement technique de nos Services (par exemple, ils vous permettent de
                            vous
                            naviguer sur un site internet et d’utiliser ses fonctionnalités).</Typography></li>
                        <li><Typography gutterBottom>Les <b>Cookies améliorant les
                            performances</b> collectent des données relatives à la performance d’un service en ligne,
                            notamment le
                            nombre de visiteurs, le temps passé sur un site internet et les messages d’erreur, nous
                            permettant
                            d’effectuer des analyses et de vous fournir des services plus personnalisés.</Typography>
                        </li>
                        <li><Typography gutterBottom>Les <b>Cookies publicitaires</b> permettent à
                            Cyklad et ses partenaires du réseau publicitaire de vous proposer des publicités
                            personnalisées.</Typography></li>
                    </ul>
                </li>
            </ul>
            <Typography gutterBottom>Les autres types de technologies de traçage, qui sont
                également appelés des « Cookies » aux termes de cette Politique d’utilisation des Cookies, sont :
                Stockage
                Local HTML5, balises web (des images électroniques aussi appelées gifs à pixel unique), pixels, cookies
                Flash
                (aussi appelés « objet local partagé » ou « OLP »), et les technologies similaires. En particulier, les
                cookies Flash sont une autre technologie de la société Adobe qui permet de fournir des fonctionnalités
                équivalentes aux cookies. Les cookies Flash permettent de stocker des informations sur votre appareil
                (dans un
                fichier en dehors de votre navigateur). Nous pouvons recourir aux cookies Flash dans certains cas où
                nous
                utilisons le Flash pour vous fournir certains contenus tels que les clips vidéo ou des
                animations.</Typography>
            <div className={classes.paragraphSpacer}/>
            <Typography variant="h2" gutterBottom className={classes.color}>
                Comment Cyklad utilise des Cookies
            </Typography>
            <br/>
            <Typography gutterBottom>Nous utilisons des Cookies à de nombreuses fins. Nous
                les utilisons, par exemple, pour :</Typography>
            <ul>
                <li><Typography gutterBottom>protéger vos informations et améliorer la
                    sécurité de nos Services.</Typography></li>
                <li><Typography gutterBottom>vous aider à vous inscrire à nos
                    Services.</Typography></li>
                <li><Typography gutterBottom>comprendre vos intérêts et besoins.</Typography>
                </li>
                <li><Typography gutterBottom>comprendre quelles fonctionnalités vous sont
                    utiles et améliorer nos Services.</Typography></li>
                <li><Typography gutterBottom>reconnaître votre appareil, réseau et navigateur
                    au fil du temps ou établir un lien entre les adresses IP, appareils mobiles et autres technologies
                    pour
                    déterminer si plusieurs appareils peuvent se rapporter au même utilisateur ou au même
                    compte.</Typography>
                </li>
                <li><Typography gutterBottom>évaluer l’efficacité de nos campagnes
                    promotionnelles.</Typography></li>
                <li><Typography gutterBottom>afficher des publicités sur nos Services ou gérer
                    nos publicités sur d’autres sites, conformément aux <a target="_blank"
                                                                           href="https://www.aboutads.info/principles"
                                                                           rel="noopener noreferrer">Principes de
                        l’Alliance Publicitaire
                        Numérique</a>.</Typography></li>
            </ul>
            <Typography gutterBottom>Cyklad utilise également des Cookies sur nos
                Services en coopération avec des réseaux publicitaires et autres partenaires tiers, notamment des médias
                sociaux, et peut fournir des Services en partenariat. Nos partenaires tiers peuvent placer des Cookies à
                la
                fois sur nos Services et sur des sites internet non-affiliés pour proposer des publicités qui peuvent
                être
                pertinentes pour vous en fonction de votre activité dans nos Services, et de vos intérêts.</Typography>
            <Typography gutterBottom>Nous incluons également des Cookies dans nos messages
                électroniques promotionnels et nos newsletters afin de déterminer si vous les ouvrez ou si vous
                interagissez
                avec ces derniers. Cela nous permet de vous proposer des contenus qui vous seront, nous l’espérons,
                utiles et
                informatifs.</Typography>
            <div className={classes.paragraphSpacer}/>
            <Typography variant="h2" gutterBottom className={classes.color}>
                Types de Cookies utilisés
            </Typography>
            <br/>
            <Typography gutterBottom>Un aperçu des Cookies utilisés sur nos Services est
                proposé dans le tableau suivant :</Typography>
            <table>
                <thead className={classes.tHead}>
                <tr>
                    <th className={classes.tH}><Typography>#</Typography></th>
                    <th className={classes.tH}><Typography>Finalité</Typography></th>
                    <th className={classes.tH}><Typography>Catégorie</Typography></th>
                    <th className={classes.tH}><Typography>Exemple / Description</Typography></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className={classes.tD} rowSpan="2"><Typography>1</Typography></td>
                    <td className={classes.tD} rowSpan="2"><Typography>Nécessaire (essentielle)</Typography></td>
                    <td className={classes.tD}><Typography>Critique</Typography></td>
                    <td className={classes.tD}><Typography>Contient des informations critiques pour votre expérience en
                        ligne (par exemple
                        les services spécifiques que vous avez demandés), ou qui contribue à des fonctionnalités de
                        personnalisation qui sont essentielles pour votre utilisation de nos Services (par exemple, les
                        préférences linguistiques).</Typography>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tD}><Typography>Sécurité</Typography></td>
                    <td className={classes.tD}><Typography>Authentifie les utilisateurs, prévient l’utilisation
                        frauduleuse des identifiants
                        de connexion et protège les informations des utilisateurs contre les accès non autorisés par des
                        tiers.</Typography>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tD}><Typography>2</Typography></td>
                    <td className={classes.tD}><Typography>Fonctionnelle</Typography></td>
                    <td className={classes.tD}><Typography>Préférence</Typography></td>
                    <td className={classes.tD}>
                        <Typography>
                            Permet à nos Services de fonctionner et offre les Services auxquels vous attendez.
                            <br/>Contient des informations importantes pour votre expérience, mais non critiques (telles
                            que la police de caractères, la personnalisation des services avec votre nom).
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tD} rowSpan="3"><Typography>1</Typography></td>
                    <td className={classes.tD} rowSpan="3"><Typography>Amélioration des performances</Typography></td>
                    <td className={classes.tD}><Typography>Sondages</Typography></td>
                    <td className={classes.tD}><Typography>Permet les activités de sondage, notamment afin que nous ne
                        vous envoyions pas le
                        même sondage plus d’une fois.</Typography>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tD}><Typography>Partage social</Typography></td>
                    <td className={classes.tD}><Typography>Vous permet d’utiliser les fonctionnalités de partage pour
                        accéder aux services
                        de médias sociaux à partir de nos Services.</Typography>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tD}><Typography>Analyses</Typography></td>
                    <td className={classes.tD}><Typography>Collecte des informations et établit un rapport statistique
                        sur l’utilisation des
                        Services.</Typography>
                    </td>
                </tr>
                <tr>
                    <td className={classes.tD}><Typography>4</Typography></td>
                    <td className={classes.tD}><Typography>Publicité</Typography></td>
                    <td className={classes.tD}/>
                    <td className={classes.tD}><Typography>Sert diverses finalités, notamment celles de vous présenter
                        des produits et
                        services qui pourraient vous intéresser, d’analyser les interactions avec les publicités sur nos
                        sites ou
                        sur des sites tiers, ou d’empêcher que les mêmes publicités ne vous soient présentées trop
                        souvent.</Typography>
                    </td>
                </tr>
                </tbody>
            </table>
            <div className={classes.paragraphSpacer}/>
            <Typography variant="h2" gutterBottom className={classes.color}>
                Contrôle des Cookies
            </Typography>
            <br/>
            <Typography gutterBottom><b>Veuillez noter</b> que même si vous refusez les
                Cookies ou la publicité basée sur les intérêts, vous continuerez à recevoir des publicités mais elles ne
                seront pas adaptées à vos intérêts. En outre, si vous vous désactivez et supprimez ultérieurement les
                Cookies,
                utilisez un navigateur différent, ou utilisez un nouvel appareil ou un appareil différent, vous serez
                peut
                être amené à renouveler vos préférences en matière de Cookies.</Typography>
            <Typography gutterBottom>Contrôle des Cookies sur nos Services :</Typography>
            <Typography gutterBottom>Les visiteurs de l’Union Européenne peuvent, à tout
                moment, gérer les Cookies de nos Services en cliquant sur le lien « Gérer les Cookies » en bas des pages
                de
                nos sites internet européens.</Typography>
            <Typography gutterBottom>De nombreux appareils et navigateurs Internet sont
                configurés pour accepter automatiquement les Cookies. Vous pouvez trouver les informations relatives aux
                paramètres de refus des Cookies dans les paramètres de votre navigateur. Si vous utilisez différents
                appareils
                pour accéder à nos Services, vous devrez vous assurer que chaque navigateur de chaque appareil est réglé
                sur
                vos préférences en matière de Cookies.</Typography>
            <Typography gutterBottom>La plupart des systèmes d'exploitation mobiles vous
                offrent une option dans les paramètres de l'appareil pour limiter la publicité ciblée associée à
                l'identifiant
                de l'appareil qu'ils peuvent partager avec nous. Veuillez consulter le centre d'aide de votre système
                d'exploitation mobile pour en savoir plus.</Typography>
            <Typography gutterBottom>Pour en savoir plus sur les Cookies, y compris comment
                voir les Cookies qui ont été configurés et comment les gérer et les supprimer, consultez les pages
                suivantes
                : <a target="_blank" href="https://en.wikipedia.org/wiki/HTTP_cookie"
                     rel="noopener noreferrer">en.wikipedia.org/wiki/HTTP_cookie</a>, <a
                    target="_blank" href="http://www.allaboutcookies.org/"
                    rel="noopener noreferrer">www.allaboutcookies.org</a>, et <a
                    target="_blank" href="http://www.aboutcookies.org"
                    rel="noopener noreferrer">www.aboutcookies.org</a>. Veuillez noter que Cyklad n'a aucun lien
                avec ces sites internet tiers et n'en est pas responsable.</Typography>
            <Typography gutterBottom>Veuillez noter que tous les navigateurs n'offrent pas
                la possibilité de supprimer les Cookies Flash. Vous pouvez restreindre ou bloquer les Cookies Flash par
                l'intermédiaire du site internet d'Adobe, en suivant les liens reproduits ci-dessous. Comme pour tous
                les
                Cookies, si vous limitez les Cookies Flash, certaines fonctionnalités de nos Services peuvent ne pas
                être
                accessibles.</Typography>
            <Typography gutterBottom>Ressources pour le contrôle des Cookies tiers
                :</Typography>
            <Typography gutterBottom>Les sites internet suivants offrent la possibilité de
                refuser le suivi par le biais de certains Cookies publicitaires et analytiques des tiers :</Typography>
            <ul>
                <li><Typography gutterBottom>Pour les utilisateurs aux États-Unis : <a
                    target="_blank" href="https://preferences-mgr.truste.com/"
                    rel="noopener noreferrer">https://preferences-mgr.truste.com/</a>.</Typography></li>
                <li><Typography gutterBottom>Pour les utilisateurs au sein de l'UE : <a
                    target="_blank" href="http://www.youronlinechoices.eu/"
                    rel="noopener noreferrer">http://www.youronlinechoices.eu/</a>.</Typography></li>
                <li><Typography gutterBottom>Consultez les pages de refus de Cookies <a
                    target="_blank" href="http://www.aboutads.info/choices/" rel="noopener noreferrer">Digital
                    Advertising Alliance's</a> ou <a
                    target="_blank" href="http://www.networkadvertising.org/choices/" rel="noopener noreferrer">Network
                    Advertising Initiative's</a>.</Typography></li>
                <li><Typography gutterBottom>Pour les utilisateurs au Royaume-Uni ou en
                    France, veuillez consulter <a target="_blank" href="https://www.youronlinechoices.eu/"
                                                  rel="noopener noreferrer">https://www.youronlinechoices.eu/</a>.</Typography>
                </li>
                <li><Typography gutterBottom>Pour les utilisateurs au Canada, veuillez
                    consulter <a target="_blank" href="https://youradchoices.ca/"
                                 rel="noopener noreferrer">https://youradchoices.ca/</a>.</Typography></li>
                <li><Typography gutterBottom><a
                    target="_blank"
                    href="https://www.facebook.com/login.php?next=https%3A%2F%2Fwww.facebook.com%2Fsettings%2F%3Ftab%3Dads"
                    rel="noopener noreferrer">Cliquez
                    ici</a> pour ne plus recevoir de publicités ciblées sur Facebook.</Typography></li>
                <li><Typography gutterBottom><a
                    target="_blank" href="https://adssettings.google.com/authenticated?hl=en" rel="noopener noreferrer">Cliquez
                    ici</a> pour désactiver Google Analytics,
                    pour afficher des publicités, ou pour personnaliser les annonces Google Display
                    Network.</Typography></li>
                <li><Typography gutterBottom>Flurry Analytics: <a
                    target="_blank" href="https://developer.yahoo.com/flurry/end-user-opt-out.html"
                    rel="noopener noreferrer">https://developer.yahoo.com/flurry/end-user-opt-out.html</a>.</Typography>
                </li>
                <li><Typography gutterBottom>Google Analytics : <a
                    target="_blank" href="https://tools.google.com/dlpage/gaoptout"
                    rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a> (nécessite
                    l'installation d'un module complémentaire sur votre navigateur).</Typography></li>
                <li><Typography gutterBottom>Kissmetrics : <a
                    target="_blank" href="https://kissmetrics.com/user-privacy"
                    rel="noopener noreferrer">https://kissmetrics.com/user-privacy</a>.</Typography></li>
                <li><Typography gutterBottom>Mixpanel : <a
                    target="_blank" href="https://mixpanel.com/optout"
                    rel="noopener noreferrer">https://mixpanel.com/optout</a>.</Typography></li>
                <li><Typography gutterBottom>Nielsen : <a
                    target="_blank" href="http://www.nielsen-online.com/corp.jsp?section=leg_prs&nav=1#Optoutchoices"
                    rel="noopener noreferrer">http://www.nielsen-online.com/corp.jsp?section=leg_prs&nav=1#Optoutchoices</a>.</Typography>
                </li>
                <li><Typography gutterBottom>Omniture (Adobe) : <a
                    target="_blank" href="http://www.d1.sc.omtrdc.net/optout.html"
                    rel="noopener noreferrer">http://www.d1.sc.omtrdc.net/optout.html</a>.</Typography>
                </li>
                <li><Typography gutterBottom>Visible Measures: <a
                    target="_blank" href="https://corp.visiblemeasures.com/viewer-settings"
                    rel="noopener noreferrer">https://corp.visiblemeasures.com/viewer-settings</a>.</Typography>
                </li>
                <li><Typography gutterBottom>WebTrends : <a
                    target="_blank" href="https://ondemand.webtrends.com/support/optout.asp"
                    rel="noopener noreferrer">https://ondemand.webtrends.com/support/optout.asp</a>.</Typography>
                </li>
                <li><Typography gutterBottom>Pour gérer les Cookies Flash, <a
                    target="_blank"
                    href="https://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
                    rel="noopener noreferrer">cliquez
                    ici</a>.</Typography></li>
                <li><Typography gutterBottom>Pour les applications mobiles, veuillez vous
                    référer aux paramètres de votre appareil mobile ou télécharger <a
                        target="_blank" href="https://youradchoices.com/appchoices" rel="noopener noreferrer">l'application
                        AppChoices</a>. Vous pouvez désactiver le suivi
                    de l’application AppChoices sur certaines applications mobiles ou les recommandations de Flurry
                    en <a
                        target="_blank" href="https://dev.flurry.com/secure/optOut.do" rel="noopener noreferrer">cliquant
                        ici</a>.</Typography></li>
            </ul>
        </div>

    )
}

export default Cookies
